module.exports = __webpack_public_path__ + "static/media/welcome_back_logo.cdd91695.png";